module.exports = __webpack_public_path__ + "static/media/ee.8c69bf38.webp";